// Module
var code = `<div class="code-filter-syscall filtered-syscall" data-filtered-conditions data-filtered-coverage data-filtered-syscall>
    <div class="code-filter-syscall-checkbox"><input class="code-filter-syscall-checkbox-input" type="checkbox" value id></div>
    <label class="code-filter-syscall-name" for> </label>
    <div class="code-filter-syscall-coverage"> </div>
    <div class="code-filter-syscall-conditions"> </div>
</div>`;
// Exports
export default code;